<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-s-order"></i> 采购单列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <div class="search-row">
          <div class="search-item">
            <span class="search-label">供应商/手机号</span>
            <el-input 
              v-model="searchForm.name" 
              placeholder="请输入供应商名称或手机号"
              prefix-icon="el-icon-search"
              clearable
              size="small"
              class="search-input"
            ></el-input>
          </div>
          <div class="search-item date-item">
            <span class="search-label">入库日期</span>
            <el-date-picker
              v-model="searchForm.start_end_date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
              class="date-picker"
            ></el-date-picker>
          </div>
          <div class="search-actions">
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search" size="small">搜索</el-button>
            <el-button @click="resetSearch" icon="el-icon-refresh-right" size="small">重置</el-button>
            <el-button type="success" @click="goAdd" icon="el-icon-plus" size="small">新增采购单</el-button>
            <el-button type="warning" @click="exportExcel" icon="el-icon-download" size="small">导出</el-button>
          </div>
        </div>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total"><i class="el-icon-document"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">采购单总数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon amount"><i class="el-icon-money"></i></div>
          <div class="stat-info">
            <div class="stat-value">¥{{ totalAmount }}</div>
            <div class="stat-label">采购总金额</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon supplier"><i class="el-icon-s-shop"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ supplierCount }}</div>
            <div class="stat-label">供应商数量</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
          
          <el-table-column label="采购信息" min-width="220">
            <template slot-scope="scope">
              <div class="purchase-info">
                <div class="purchase-sn">
                  <i class="el-icon-document"></i>
                  <span>单号：{{ scope.row.sn }}</span>
                </div>
                <div class="supplier-name">
                  <i class="el-icon-s-shop"></i>
                  <span>{{ scope.row.shop ? scope.row.shop.name : '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="入库信息" min-width="180">
            <template slot-scope="scope">
              <div class="entry-info">
                <div class="entry-person">
                  <i class="el-icon-user"></i>
                  <span>入库人：{{ scope.row.executor ? scope.row.executor.name_cn : '-' }}</span>
                </div>
                <div class="entry-time">
                  <i class="el-icon-date"></i>
                  <span>入库日期：{{ scope.row.enter_time | dateFormat }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="收货信息" min-width="220">
            <template slot-scope="scope">
              <div class="receive-info">
                <div class="receiver">
                  <i class="el-icon-user-solid"></i>
                  <span>{{ scope.row.consignee || '-' }}</span>
                  <span class="phone">({{ scope.row.tel || '-' }})</span>
                </div>
                <div class="address">
                  <i class="el-icon-location"></i>
                  <span>{{ scope.row.address || '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="操作时间" width="160" align="center">
            <template slot-scope="scope">
              <span class="time-text">{{ scope.row.add_time | timeFormat }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="200" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" class="detail-btn" @click="showDetail(scope.row)">
                <i class="el-icon-view"></i> 详情
              </el-button>
              <el-button type="text" size="mini" class="edit-btn" @click="goInfo(scope.row)">
                <i class="el-icon-edit-outline"></i> 编辑
              </el-button>
              <el-button type="text" size="mini" class="delete-btn" @click="handleDelete(scope.row)">
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-document"></i>
        <p>暂无采购单数据</p>
        <el-button type="primary" size="mini" @click="goAdd">立即添加</el-button>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 详情抽屉 -->
    <el-drawer
      title="采购单详情"
      :visible.sync="drawer"
      :with-header="false"
      size="500px"
      class="custom-drawer"
    >
      <div class="drawer-header">
        <h3>采购单详情</h3>
        <i class="el-icon-close" @click="drawer = false"></i>
      </div>
      <div class="drawer-content">
        <el-table
          :data="detail_list"
          stripe
          border
          size="medium"
          :header-cell-style="headerCellStyle"
        >
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column label="产品名称" prop="product_name" min-width="150">
            <template slot-scope="scope">
              <div class="product-name">
                <i class="el-icon-goods"></i>
                <span>{{ scope.row.product ? scope.row.product.name : '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="count" width="100" align="center">
            <template slot-scope="scope">
              <span class="quantity">{{ scope.row.count || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="80" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.product ? scope.row.product.unit : '-' }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="detail_list.length === 0" class="empty-detail">
          <i class="el-icon-document"></i>
          <p>暂无采购明细</p>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import * as XLSX from 'xlsx'

export default {
  name: "purchaseList",
  data() {
    return {
      loading: false,
      
      // 搜索表单
      searchForm: {
        name: "",
        start_end_date: ""
      },
      
      // 统计数据
      totalAmount: 0,
      supplierCount: 0,
      
      // 表格数据
      tableLoadData: [],
      selectedRows: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      // 详情抽屉
      drawer: false,
      detail_list: []
    }
  },
  created() {
    this.DataList()
  },
  filters: {
    dateFormat(time) {
      if (!time) return ""
      return moment(time * 1000).format("YYYY-MM-DD")
    },
    timeFormat(time) {
      if (!time) return ""
      return moment(time * 1000).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  methods: {
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    rowStyle() { return { cursor: 'pointer' } },
    
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    
    calculateStats() {
      if (!this.tableLoadData.length) {
        this.totalAmount = 0
        this.supplierCount = 0
        return
      }
      this.totalAmount = this.tableLoadData.reduce((sum, item) => sum + (parseFloat(item.total_amount) || 0), 0).toFixed(2)
      const uniqueSuppliers = new Set(this.tableLoadData.map(item => item.shop_id))
      this.supplierCount = uniqueSuppliers.size
    },
    
    resetSearch() {
      this.searchForm = { name: "", start_end_date: "" }
      this.pageNum = 1
      this.DataList()
      this.$message.success('已重置搜索条件')
    },
    
    indexMethod(index) { return (this.pageNum - 1) * this.pageSize + index + 1 },
    
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.searchForm.name) param.name = this.searchForm.name
      if (this.searchForm.start_end_date && this.searchForm.start_end_date.length === 2) {
        param.start_time = this.searchForm.start_end_date[0]
        param.end_time = this.searchForm.start_end_date[1]
      }
      
      this.$axios.findPurchaseListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    showDetail(row) {
      this.detail_list = row.detail || []
      this.drawer = true
    },
    
    goInfo(row) {
      this.$router.push({ path: '/purchaseInfo', query: { id: row.id } })
    },
    
    goAdd() {
      this.$router.push({ path: '/hisPurchaseForm' })
    },
    
    handleDelete(row) {
      this.$confirm(`确定要删除采购单"${row.sn}"吗？删除后无法恢复`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        const param = {
          id: row.id,
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token')
        }
        this.$axios.delPurchase(param).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.DataList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    
    exportExcel() {
      if (!this.tableLoadData.length) {
        this.$message.warning('暂无数据可导出')
        return
      }
      
      const exportData = this.tableLoadData.map((row, index) => ({
        '序号': index + 1,
        '采购单号': row.sn,
        '供应商名称': row.shop?.name || '--',
        '入库人': row.executor?.name_cn || '--',
        '入库日期': moment(row.enter_time * 1000).format('YYYY-MM-DD'),
        '收货人': row.consignee || '--',
        '收货电话': row.tel || '--',
        '收货地址': row.address || '--',
        '操作时间': moment(row.add_time * 1000).format('YYYY-MM-DD HH:mm:ss')
      }))
      
      const worksheet = XLSX.utils.json_to_sheet(exportData)
      worksheet['!cols'] = [
        { wch: 8 }, { wch: 22 }, { wch: 20 }, { wch: 12 },
        { wch: 12 }, { wch: 12 }, { wch: 15 }, { wch: 30 }, { wch: 20 }
      ]
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '采购单列表')
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `采购单列表_${moment().format('YYYYMMDDHHmmss')}.xlsx`
      link.click()
      URL.revokeObjectURL(link.href)
      this.$message.success(`成功导出 ${this.tableLoadData.length} 条数据`)
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 搜索栏
.search-bar {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .search-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
  }
  
  .search-item {
    display: flex;
    align-items: center;
    gap: 8px;
    .search-label { font-size: 13px; color: #606266; white-space: nowrap; min-width: 100px; text-align: right; }
    .search-input { width: 220px; }
    .date-picker { width: 260px; }
  }
  
  .search-actions {
    display: flex;
    gap: 10px;
    margin-left: auto;
    .el-button { border-radius: 20px; padding: 8px 18px; }
    .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; } }
    .el-button--success { background: #00b578; border-color: #00b578; &:hover { background: #1acd8c; } }
    .el-button--warning { background: #e6a23c; border-color: #e6a23c; &:hover { background: #ebb563; } }
  }
}

// 统计卡片
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 140px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 16px 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon {
      width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff;
      &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.amount { background: linear-gradient(135deg, #ffb980, #ffd666); }
      &.supplier { background: linear-gradient(135deg, #00b578, #1acd8c); }
    }
    .stat-info {
      .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; }
      .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; }
    }
  }
}

// 表格样式
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }

.purchase-info, .entry-info, .receive-info {
  .purchase-sn, .entry-person, .receiver { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; i { font-size: 14px; } }
  .supplier-name, .entry-time, .address { display: flex; align-items: center; gap: 6px; i { font-size: 12px; color: #8c8f98; } span { font-size: 12px; color: #8c8f98; } }
  .purchase-sn i, .supplier-name i { color: #1677ff; }
  .receiver i { color: #00b578; }
  .phone { margin-left: 8px; color: #8c8f98; }
}

.time-text { font-size: 12px; color: #8c8f98; }

.detail-btn { color: #909399; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #a6a9ad; } }
.edit-btn { color: #1677ff; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #4096ff; } }
.delete-btn { color: #ff4d4f; i { margin-right: 4px; } &:hover { color: #ff7875; } }

.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } .el-button { margin-top: 20px; border-radius: 20px; } }
.pagination-wrapper { display: flex; justify-content: flex-end; padding-top: 16px; border-top: 1px solid #f0f0f0; .el-pagination .el-pager li.active { background: #1677ff; color: #fff; } }

// 抽屉样式
.custom-drawer {
  ::v-deep .el-drawer__body { padding: 0; }
}

.drawer-header {
  display: flex; justify-content: space-between; align-items: center; padding: 20px 24px; background: linear-gradient(135deg, #1677ff, #4096ff); color: #fff;
  h3 { margin: 0; font-size: 18px; font-weight: 500; }
  i { font-size: 20px; cursor: pointer; &:hover { opacity: 0.8; } }
}

.drawer-content { padding: 20px 24px; }
.product-name { display: flex; align-items: center; gap: 8px; i { color: #e6a23c; } }
.quantity { font-weight: 600; color: #e6a23c; }
.empty-detail { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 48px; } p { margin-top: 16px; } }
</style>